export default "__VITE_PUBLIC_ASSET__ead30569__"